class WebSocketParserService {
    constructor() {
      this.connection = null;
      this.connectionId = null;
      this.handlers = new Map();
      this.WS_URL_BASE = `${process.env.REACT_APP_WEB_SOCKET}`;
      this.manualClose = false;
    }
  
    on(eventName, callback) {
      if (!this.handlers.has(eventName)) this.handlers.set(eventName, []);
      const eventHandlers = this.handlers.get(eventName);
  
      if (!eventHandlers.includes(callback)) eventHandlers.push(callback);
  
      return () => {
        const index = eventHandlers.indexOf(callback);
        if (index > -1) eventHandlers.splice(index, 1);
      };
    }
  
    emit(eventName, data) {
      if (this.handlers.has(eventName)) {
        this.handlers.get(eventName).forEach(cb => {
          try {
            cb(data);
          } catch (err) {
            console.error(`Error in handler for ${eventName}:`, err);
          }
        });
      }
    }
  
    connect(connectionId) {
      if (!this.WS_URL_BASE) {
        this.emit('error', { message: "WebSocket service not configured." });
        return;
      }
  
      if (this.connection && [WebSocket.OPEN, WebSocket.CONNECTING].includes(this.connection.readyState)) {
        console.log(`⏳ Already connecting/open for ${connectionId}`);
        return;
      }
  
      this.disconnect();
      this.manualClose = false;
      this.connectionId = connectionId;
      const wsUrl = `${this.WS_URL_BASE}/${connectionId}`;
      console.log(`🔗 Connecting to WebSocket: ${wsUrl}`);
  
      this.connection = new WebSocket(wsUrl);
  
      this.connection.onopen = () => {
        console.log(`✅ WebSocket connected for ${connectionId}`);
        clearTimeout(this.connectionTimeout); // Clear timeout on successful connection
        this.emit('open', { message: 'Connection established' });
      };
  
      this.connection.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          console.log("📩 Message:", msg);
  
          if (msg.status === 'CONNECTING') return;
          if (msg.status === 'NOT_FOUND') return this.emit('error', msg.message);
  
          switch (msg.profile_status) {
            case 'IN_PROGRESS':
              this.emit('progress', msg);
              break;
            case 'SUCCESS':
              this.emit('success', msg);
              break;
            case 'COMPLETE':
              this.emit('complete', msg);
              break;
            case 'FAILED':
              this.emit('failed', msg);
              break;
            default:
              console.warn("⚠️ Unknown profile_status:", msg.profile_status);
          }
        } catch (err) {
          console.error("❌ Invalid WebSocket message:", err);
          this.emit('error', { message: 'Invalid message from server.' });
        }
      };
  
      this.connection.onerror = (error) => {
        console.error(`WebSocket error for ${connectionId}:`, error);
      };
  
      this.connection.onclose = (event) => {
        console.log(`🔌 WebSocket closed for ${this.connectionId}`, event.reason);
        this.connection = null;
        this.connectionId = null;
  
        if (!this.manualClose) {
          this.emit('close', { message: 'Connection closed unexpectedly.' });
        }
      };
      this.connectionTimeout = setTimeout(() => {
        if (this.connection && this.connection.readyState !== WebSocket.OPEN) {
          console.error('Connection timeout');
          this.emit('error', { message: 'Connection timeout.' });
        }
      }, 10000);
    }
  
    disconnect() {
      if (this.connection) {
        this.manualClose = true;
        console.log("🛑 Disconnecting WebSocket...");
        try {
          this.connection.close(1000, 'Normal Closure');
        } catch (err) {
          console.warn("Error while closing WebSocket:", err);
        }
      }
      this.connection = null;
      this.connectionId = null;
    }
  
    clearAllHandlers() {
      this.handlers.clear();
    }
  }
  
  const webSocketParserService = new WebSocketParserService();
  export default webSocketParserService;